import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";

export interface MenuLinkProps {
  icon: any;
  url: string;
}

export const MenuLink = ({ icon, url }: MenuLinkProps) => {
  return (
    <div className="flex-1 group">
      <NavLink
        to={url}
        className="flex items-end justify-center text-center mx-auto w-full text-teal-500 group-hover:text-teal-700 border-b-2 border-transparent group-hover:border-teal-700"
      >
        <span className="block">
          <FontAwesomeIcon icon={icon} className="text-2xl  px-3 py-4" />
        </span>
      </NavLink>
    </div>
  );
};

const FootNav = () => {
  return (
    <div className="block fixed inset-x-0 bottom-0 z-10 bg-white shadow-md">
      <div className="flex">
        <MenuLink icon={solid("home")} url={"/"} />
        <MenuLink icon={solid("search")} url={"/explorer"} />
        <MenuLink icon={solid("play")} url={"/reel"} />
        <MenuLink icon={solid("shopping-bag")} url={"/shop"} />
        <MenuLink icon={solid("user")} url={"/profile"} />
      </div>
    </div>
  );
};

export default FootNav;
